module.exports = __webpack_public_path__ + "img/default_img5.961dfcec.webp";